import { Badge, Box } from "@material-ui/core";
import { NotificationsNone } from "@mui/icons-material";
import React from "react";
import { NotificationsActive } from "@material-ui/icons";

interface BadeNotificationProps {
  className?: string;
  style?: any;
  max?: number;
  nbrOfNotifications?: number;
  iconStyle?: any;
  sx?: any;
}

export const BadgeNotifications = (props: BadeNotificationProps) => {
  return (
    <Box className={props.className} style={props.style} sx={props.sx}>
      <Badge
        badgeContent={props.nbrOfNotifications}
        color="error"
        max={props.max || 10}
      >
        {props.nbrOfNotifications && props.nbrOfNotifications > 0 ? (
          <NotificationsActive style={props.iconStyle} />
        ) : (
          <NotificationsNone style={props.iconStyle} />
        )}
      </Badge>
    </Box>
  );
};
